<template>
  <div>

   <vue-good-table
     :columns="columns"
     :rows="list"

     :search-options="searchOpts"
     :sort-options="sortOpts"
     :pagination-options="pagOpts"
     :group-options="groupOpts"

     :row-style-class="rowStyle"

     :compact-mode="compact"
     :fixed-header="fixedHeader"
     :line-numbers="lineNumbers"
     :rtl="rtl"

     :max-height="maxHeight"

    :style-class="'vgt-table' + (striped ? ' striped' : '') + (bordered ? ' bordered' : '')"
    :theme="theme"

   />

  </div>
</template>

<script>

import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'good-table',

  components: {
    VueGoodTable
  },

  props: {
    cols: {
      type: Array,
      required: true
    },

    rows: {
      type: Array,
      required: true
    },

    search: {
      type: Boolean,
      default: true
    },

    sort: {
      type: Boolean,
      default: true
    },

    sortParams: {
      type: Object,
      default: null
    },

    striped: {
      type: Boolean,
      default: false
    },

    bordered: {
      type: Boolean,
      default: false
    },

    compact: {
      type: Boolean,
      default: true
    },

    pagination: {
      type: Boolean,
      default: true
    },

    perPage: {
      type: Number,
      default: 10
    },

    lineNumbers: {
      type: Boolean,
      default: false
    },

    group: {
      type: Boolean,
      default: false
    },

    fixedHeader: {
      type: Boolean,
      default: false
    },

    rtl: {
      type: Boolean,
      default: false
    },

    maxHeight: {
      type: String,
      default: null
    },

    rowStyle: {
      type: [String, Function],
      default: null
    },

    theme: {
      type: String,
      default: null,
      validator(value) {
        return ['black-rhino', 'polar-bear', 'nocturnal'].includes(value)
      }
    }

  },

  watch: {
    cols: function (c) {
      this.columns = []
      this.columns = c
    },


    rows: function (r) {
      this.list = []
      this.list = r
    }

  },

  data () {
    return {
      columns: this.cols,
      list: this.rows,
      groupOpts: {
        enabled: this.group
      },
      searchOpts: {
        enabled: this.search
      },
      sortOpts: {
        enabled: this.sort,
        initialSortBy: this.sortParams
      },
      pagOpts: {
          enabled: this.pagination,
          mode: 'records',
          perPage: this.perPage,
          jumpFirstOrLast: true
      }
    }
  }
}

</script>
